import { browser } from "$app/environment";
import {
    loadStorageEstablecimiento,
    saveStorageEstablecimiento,
} from "$lib/java/establecimientos/establecimientostorage";

// Establecimiento activo, reactivo y global (una sola fuente de verdad).
// Sincronizado con localStorage("establecimiento"). Cambiar `id` dispara el
// re-montaje de la pantalla actual (vía {#key activeEst.id} en el layout), que
// vuelve a leer el establecimiento de localStorage y muestra sus datos.
// Permite cambiar de establecimiento SIN recargar la página (multi-establecimiento).
export const activeEst = $state({ exist: false, nombre: "", id: "" });

if (browser) {
    const s = loadStorageEstablecimiento();
    activeEst.exist = s?.exist ?? false;
    activeEst.nombre = s?.nombre ?? "";
    activeEst.id = s?.id ?? "";
}

// Cambia el establecimiento activo: persiste en localStorage y muta el estado
// reactivo (lo segundo dispara el re-montaje vía {#key}).
export function setActiveEst({ id, nombre, exist = true }) {
    saveStorageEstablecimiento({ exist, id, nombre });
    activeEst.exist = exist;
    activeEst.nombre = nombre;
    activeEst.id = id;
}
